<template>
    <div :class="{ 'rich-text-container': fixedToolbar }" ref="container">
        <VueEditor
            ref="editor"
            :useCustomImageHandler="true"
            @image-added="handleImageAdded"
            v-model="descripcion"
            :editorOptions="editorSettings"
            :disabled="readonly"
        ></VueEditor>
    </div>
</template>
<script>
import { VueEditor, Quill } from "vue2-editor";
import ImageResize from "quill-image-resize-vue";
import QuillImageDropAndPaste from "quill-image-drop-and-paste";
import CustomClipboardPlugin from "../../../utils/quillScrollPosition";

Quill.register("modules/imageDropAndPaste", QuillImageDropAndPaste);
Quill.register("modules/imageResize", ImageResize);

export default {
    components: { VueEditor },
    props: ["value", "uploadUrl", "fixedToolbar", "readonly"],
    data() {
        return {
            descripcion: null,
            lastKnownRange: null,
            editorSettings: {
                modules: {
                    imageDropAndPaste: {
                        handler: this.handleImageAdded,
                    },
                    imageResize: {},
                },
            },
            customModulesForEditor: [
                { alias: "clipboard", module: CustomClipboardPlugin },
            ],
        };
    },
    created() {
        this.descripcion = this.value;
    },
    mounted() {
        if (this.$refs.editor) {
            const quill = this.$refs.editor.quill;
            
            // Deshabilitar editor si es readonly
            if (this.readonly) {
                quill.enable(false);
            }

            // Guardar la selección cuando cambia
            quill.on("selection-change", (range) => {
                if (range) {
                    this.lastKnownRange = range;
                }
            });

            // Observar cuando aparece el tooltip de links
            const observer = new MutationObserver((mutations) => {
                mutations.forEach((mutation) => {
                    mutation.addedNodes.forEach((node) => {
                        if (
                            node.classList &&
                            node.classList.contains("ql-tooltip")
                        ) {
                            const saveButton = node.querySelector("button");
                            if (saveButton) {
                                const originalClick = saveButton.onclick;
                                saveButton.onclick = (e) => {
                                    const range = this.lastKnownRange;
                                    if (originalClick) {
                                        originalClick.call(saveButton, e);
                                    }
                                    setTimeout(() => {
                                        if (range) {
                                            quill.setSelection(
                                                range.index,
                                                range.length
                                            );
                                        }
                                    }, 1);
                                };
                            }
                        }
                    });
                });
            });

            observer.observe(quill.container, {
                childList: true,
                subtree: true,
            });

            // Guardar el observer para limpiarlo después
            this.tooltipObserver = observer;
        }
    },
    methods: {
        async handleImageAdded(file) {
            const quill = this.$refs.editor.quill;
            const Editor = this.$refs.editor.quill.editor;
            const range = this.$refs.editor.quill.getSelection();
            const cursorLocation = await range.index;
            // Editor.insertEmbed(cursorLocation, "image", file);

            // An example of using FormData
            // NOTE: Your key could be different such as:
            // formData.append('file', file)

            var formData = new FormData();
            formData.append("image", file);

            axios({
                url: this.uploadUrl,
                method: "POST",
                data: formData,
            })
                .then((result) => {
                    const url = result.data.url; // Get url from response
                    Editor.insertEmbed(cursorLocation, "image", url);
                    this.descripcion = quill.root.innerHTML;
                })
                .catch((err) => {});
        },
    },
    watch: {
        descripcion(val) {
            this.$emit("input", val);
            // console.log("rich2", val);
        },
        value(val) {
            this.descripcion = val;
            // console.log("rich", val);
        },
        readonly(val) {
            if (this.$refs.editor) {
                const quill = this.$refs.editor.quill;
                quill.enable(!val);
            }
        },
    },
    beforeDestroy() {
        if (this.$refs.editor) {
            const quill = this.$refs.editor.quill;
            quill.off("selection-change");

            // Limpiar el observer
            if (this.tooltipObserver) {
                this.tooltipObserver.disconnect();
            }
        }
    },
};
</script>
<style>
/* Agregar estilos para mejorar la experiencia 'el to'lbar */
.ql-toolbar.ql-snow {
    user-select: none;
}

.ql-toolbar.ql-snow button:focus {
    outline: none;
}

.ql-toolbar.ql-snow .ql-formats {
    margin-right: 15px;
}
.rich-text-container {
    position: relative;
    height: 100%;
    display: flex;
    flex-direction: column;
}

.rich-text-container .ql-toolbar {
    position: sticky;
    top: 88px;
    z-index: 100;
    background: white;
    border-bottom: 1px solid #ccc;
    flex: 0 0 auto;
}

.rich-text-container .ql-container {
    flex: 1 1 auto;
    overflow-y: auto;
    height: auto !important;
}

.rich-text-container .ql-editor {
    min-height: 100%;
}
</style>
